module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-2-a9bf38716b7847e7c7ab45f283ab05e0.jpg";